module.exports = __webpack_public_path__ + "img/x-Sh.6236bad0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Sh.jpg
// module id = 8nTZ
// module chunks = 1